import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { ASSIGNEE_LIST, ASSIGNEE } from './type';

function assigneePayload(res) {
  const body = res?.data;
  return body?.data ?? body?.response?.data ?? null;
}

export const getAssigneeList = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.assignee.dropdownData}?lead_id=${leadId}`
  );
  const payload = assigneePayload(res);
  if (payload) {
    dispatch({ type: ASSIGNEE_LIST, payload });
    return true;
  }
};

export const getAssignee = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesList.assignes}`
  );
  const payload = assigneePayload(res);
  if (payload) {
    dispatch({ type: ASSIGNEE, payload });
    return true;
  }
};

export const postAssignee = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.assignee.postAssignee
  );
  if (res) {
    return true;
  } else {
    return null;
  }
};

export const postBulkAssignment = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.bulkAssignment
  );
  if (
    res?.data?.status === 0 ||
    res?.data?.status === true ||
    res?.data?.response?.status === true
  ) {
    return true;
  } else {
    return false;
  }
};
